<template>
  <div>
    <search-finance-ledger-open-channel-payments @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          v-if="isShowMenu('finance_ledger/open_channel_payments/export')"
          type="primary"
          @click="exportData"
        >
          导出
        </a-button>
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 1900 }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import SearchFinanceLedgerOpenChannelPayments from '@/views/finance_ledger/SearchOpenChannelPayments'
import Pagination from '@/components/Pagination'
import { findFinanceLedgerOpenChannelPayments, exportFinanceLedgerOpenChannelPayments } from '@/api/finance_ledger'
import { exportExcel } from '@/api/excel'
import { formatCurrency } from '@/utils/filter'

export default {
  name: 'FinanceLedgerOpenChannelPayments',
  components: {
    SearchFinanceLedgerOpenChannelPayments,
    Pagination
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {}
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '商户订单号',
          width: 180,
          dataIndex: 'out_trade_no'
        },
        {
          title: '业务类型',
          width: 90,
          dataIndex: 'operation_type'
        },
        {
          title: '订单标题',
          width: 140,
          ellipsis: true,
          dataIndex: 'subject'
        },
        {
          title: '支付金额(元)',
          width: 100,
          customRender: formatCurrency,
          dataIndex: 'amount'
        },
        {
          title: '分佣金额(元)',
          width: 110,
          customRender: (text) => (text > 0 ? formatCurrency(text) : ''),
          dataIndex: 'commission_fee'
        },
        {
          title: '支付方式',
          width: 100,
          dataIndex: 'pay_way'
        },
        {
          title: '支付时间',
          width: 170,
          dataIndex: 'paid_at'
        },
        {
          title: '客户名称',
          width: 140,
          ellipsis: true,
          dataIndex: 'top_agent_name'
        },
        {
          title: '最下级客户',
          width: 140,
          ellipsis: true,
          dataIndex: 'agent_name'
        },
        {
          title: '支付用户',
          width: 100,
          dataIndex: 'pay_user_name'
        },
        {
          title: '第三方交易号',
          width: 180,
          ellipsis: true,
          dataIndex: 'transaction_id'
        },
        {
          title: '开放渠道',
          width: 100,
          dataIndex: 'open_channel'
        },
        {
          title: '卡号',
          width: 200,
          ellipsis: true,
          dataIndex: 'iccids'
        },
        {
          title: '渠道订单号',
          width: 160,
          dataIndex: 'open_channel_order_no'
        },
        {
          title: '记录时间',
          width: 170,
          dataIndex: 'created_at'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findFinanceLedgerOpenChannelPayments(this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    },

    exportData() {
      exportFinanceLedgerOpenChannelPayments(this.query).then((res) => {
        if (res.code === 0 && res.data.is_direct_download === true) {
          exportExcel(res.data.id, res.data.file_name)
        }
      })
    }
  }
}
</script>
